<template>
	<div class="restrictOrientation">
		<div class="rotateText" v-html="game_config.device_orientation_message"></div>
		<div class="rotateIcon">
			<img :src="game_config.device_orientation_image" />
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'RestrictOrientation',
	mixins: [msEdgeImageSwap],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss">
.restrictOrientation {
	display: none;
	@media screen and (orientation: portrait) {
		display: block;
		width: 95vw;
		height: 95vh;
		overflow-x: hidden;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: $gold;
		border: 5px solid black;
		color: black;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		z-index: 19999;
		@include breakpoint(xsm){
			border-width: 3px;
		}
		.rotateText{
			padding: 0;
			margin: 10% 0;
			& h1{
				font-family: $sabo-filled;
				@include breakpoint(xsm){
					font-size: 2.2em;
				}
				@include breakpoint(xs){
					font-size: 1.6em;
				}
			}
			& p{
				font-size: 1.5em;
				@include breakpoint(xsm){
					font-size: 1.3em;
				}
				@include breakpoint(xs){
					font-size: 1.1em;
				}
			}
		}
		.rotateIcon{
			margin: 20px auto 0 auto;
			padding: 0 10%;
			width: 100%;
			img{
				width: 100%;
				height: auto;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/RestrictOrientation.vue